import { Box } from '@mui/material'
import React from 'react'
import { useQuery } from 'react-query'
import {
  getPersonalData,
  getTaxData,
} from 'services/api/modules/staff-management/staffManagementDashboard'
import Household from './Household'
import PersonalDetails from './PersonalDetails'

const BasicDetails = ({ employeeId, time_id }) => {
  const { data: tax } = useQuery(['employeeTaxData', employeeId], async () => {
    const { data } = await getTaxData(employeeId)
    return data
  })
  const { data: personal } = useQuery(['employeePersonalData', employeeId], async () => {
    const { data } = await getPersonalData(employeeId)
    return data
  })
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
        <PersonalDetails
          data={tax}
          employeeId={employeeId}
          personalDeets={personal}
          time_id={time_id}
        />
      </Box>
      <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
        <Household data={tax} employeeId={employeeId} time_id={time_id} />
      </Box>
    </Box>
  )
}

export default BasicDetails
